import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import App from './App';
import { store } from './store';
import config from './config/env';
import './styles/global.scss';

// Initialize Stripe with publishable key from environment config
const stripePromise = loadStripe(config.stripeKey);

// Stripe Elements options - German locale for proper formatting
const stripeElementsOptions = {
  locale: 'de' as const,
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Elements stripe={stripePromise} options={stripeElementsOptions}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Elements>
    </Provider>
  </React.StrictMode>
);

